import { Pipe, PipeTransform } from '@angular/core';

import { isEmpty } from 'lodash';

@Pipe({
	name: 'fullName',
})
export class FullNamePipe implements PipeTransform {
	transform(person: { firstName: string, lastName: string }, alternateText: string): string {
		const fullName = person ? `${person.firstName} ${person.lastName}`.trim() : '';

		return isEmpty(fullName)
			? isEmpty(alternateText) ? '' : alternateText
			: fullName;
	}
}
